module.exports = __webpack_public_path__ + "img/fitness.ba3d72ca.jpg";